import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToastMessageService } from 'src/app/toastr.service';
import { RightsWiseLoginService } from './rights-wise-login.service';

@Component({
  selector: 'app-rights-wise-login',
  templateUrl: './rights-wise-login.component.html',
  styleUrl: './rights-wise-login.component.scss',
  // standalone: true,
  // imports: [MultiSelectModule]
})
export class RightsWiseLoginComponent {
  userForm: FormGroup;
  userData: any;
  selectedUser: any = null;
  isEditing: boolean = false;
  selectedSidebarOption: { name: string; code: string }[] = [];
  email: any;
  displayDeleteDialogBox: boolean = false;
  displayUpdateDialogBox: boolean = false;
  deleteUserId: string | null = null;
  deleteUserEmail: string | null = null;
  isPasswordVisible = false;
  selectedFieldOptions: any[] = [];
  showSectionDropdown: false;
  selectedAccessOption: any;
  selectedSection: string;
  selectedFields: string[] = [];

  pageAccessOptions = [
    { name: 'Retrieve Innovator Brand Product Details', code: 'RetrieveInnovatorBrandProductDetails' },
    { name: 'API Information', code: 'APIInformation' },
    { name: 'Clinical Information', code: 'ClinicalInformation' },
    { name: 'Competitive Intelligence', code: 'CompetitiveIntelligence' },
    { name: 'Costing Related Others', code: 'CostingRelatedOthers' },
    { name: 'Executive Summary', code: 'ExecutiveSummary' },
    { name: 'Formulation Information', code: 'FormulationInformation' },
    { name: 'Regulatory Information', code: 'RegulatoryInformation' },
    { name: 'Patent Information', code: 'PatentInformation' },
    { name: 'Litigation Information', code: 'LitigationInformation' },
  ];

  sidebarAccessOptions = [
    { name: 'Data Directory', code: 'Data Directoryssss' },
    { name: 'Search Molecule', code: 'Search Molecule' },
    { name: 'Costing', code: 'Costing' },
    { name: 'Business Case', code: 'Business Case' },
    { name: 'Est API', code: 'Est API' },
    { name: 'Est RLD', code: 'Est RLD' },
    { name: 'Commercial Intelligence', code: 'Commercial Intelligence' },
    { name: 'Upload Files', code: 'Upload Files' },
    { name: 'File Sales and Volume', code: 'File Sales and Volume' },
    { name: 'Scraping Update', code: 'Scraping Update' },
    { name: 'LMS', code: 'LMS' },
    { name: 'PDUFA', code: 'PDUFA' },
    { name: 'Error Dashboard', code: 'Error Dashboard' },
    { name: 'Upload To Live', code: 'Upload To Live' },
    { name: 'User Registration', code: 'User Registration' },
    { name: 'Company Master', code: 'Company Master' },
    { name: 'Request Training', code: 'Request Training' },
    { name: 'Product Dashboard', code: 'Product Dashboard' },
    { name: 'Excel Manager', code: 'Excel Manager' },
    { name: 'Peak Sale', code: 'Peak Sale' },
    { name: 'Email Litigation', code: 'Email Litigation' },
    { name: 'Litigation Complaints', code: 'Litigation Complaints' },
    { name: 'Rights Wise Access', code: 'Rights Wise Access' },
    { name: 'Subscriber Mail Users', code: 'Subscriber Mail Users' },
    { name: 'New Subscriber Email', code: 'New Subscriber Email' },
    { name: 'Field Reviews Dashboard', code: 'Field Reviews Dashboard' },
    { name: 'Product Status Dashboard', code: 'Product Status Dashboard' },
    { name: 'Excel Dump Dashboard', code: 'Excel Dump Dashboard' },
    { name: 'Important Updates', code: 'Important Updates' },
    { name: 'Section Wise Email', code: 'Section Wise Email' },
    { name: 'Get Most Searched', code: 'Most Searched Products' },
    { name: 'LMS DS Manual Entry', code: 'LMS DS Manual Entry' },
    { name: 'Push to Live', code: 'Push to Live' },
    { name: 'PTE Events', code: 'PTE Events' },
    { name: 'Upload Shortage File', code: 'Shortage Excel Panel' },
    { name: 'Shortage Panel', code: 'Shortage Excel Panel' }
  ];

  lmsAccessOptions = [
    { name: 'LMS DB', code: 'LMS DB' },
    { name: 'LMS DS', code: 'LMS DS' },
    { name: 'LMS SU', code: 'LMS SU' },
    { name: 'LMS MS', code: 'LMS MS' },
    { name: 'LMS EX-DB', code: 'LMS EX-DB' },
    { name: 'LMS EL', code: 'LMS EL' },
    { name: 'LMS RC', code: 'LMS RC' },
    { name: 'LMS EX-DB-IM', code: 'LMS EX-DB-IM' },
    { name: 'LMS Business Case', code: 'LMS Business Case' },
    { name: 'LMS ELR', code: 'LMS ELR' },
    { name: 'LMS CL-AI', code: 'LMS CL-AI' },
    { name: 'LMS SP', code: 'LMS SP' }
  ];

  sectionDropdownOptions = [
    { name: 'INNOVATOR/BRAND PRODUCT DETAILS', code: 'INNOVATOR/BRAND PRODUCT DETAILS' },
    { name: 'PATENT INFORMATION', code: 'PATENT INFORMATION' },
    { name: 'REGULATORY INFORMATION', code: 'REGULATORY INFORMATION' },
    { name: 'CLINICAL INFORMATION', code: 'CLINICAL INFORMATION' },
    { name: 'API INFORMATION', code: 'API INFORMATION' },
    { name: 'FORMULATION INFORMATION', code: 'FORMULATION INFORMATION' },
    { name: 'COMPETITIVE INTELLIGENCE', code: 'COMPETITIVE INTELLIGENCE' },
    { name: 'EXECUTIVE SUMMARY', code: 'EXECUTIVE SUMMARY' },
    { name: 'COSTING RELATED AND DETAILS', code: 'COSTING RELATED AND DETAILS' },
    // { name: 'LITIGATION INFORMATION', code: 'LITIGATION INFORMATION' },
  ];

  fieldOptionsBySection = {
    'INNOVATOR/BRAND PRODUCT DETAILS': [
      { name: 'Brand Name/Proprietary Name', code: 'Brand Name/Proprietary Name' },
      { name: 'Active Ingredient', code: 'Active Ingredient' },
      { name: 'Strengths (mg)', code: 'Strengths (mg)' },
      { name: 'Route of Administration', code: 'Route of Administration' },
      { name: 'Dosage forms', code: 'Dosage forms' },
      { name: 'Nature of Dosage form', code: 'Nature of Dosage form' },
      { name: 'NDA number', code: 'NDA number' },
      { name: 'Submission Classification', code: 'Submission Classification' },
      { name: 'Approval date / Action date (mm-dd-yyyy)', code: 'Approval date / Action date (mm-dd-yyyy)' },
      { name: 'Innovator / Applicant Holder', code: 'Innovator / Applicant Holder' },
      { name: 'Marketing Status', code: 'Marketing Status' },
      { name: 'Dosage and Administration', code: 'Dosage and Administration' },
      { name: 'Indications and Usage', code: 'Indications and Usage' },
      { name: 'Recommended dose', code: 'Recommended dose' },
      { name: 'FDA label', code: 'FDA label' },
      { name: 'Approved in other geographies', code: 'Approved in other geographies' },
      { name: 'Oneclick Marketing Status', code: 'Oneclick Marketing Status' },
      { name: 'StrengthActiveAPIFillVolume', code: 'StrengthActiveAPIFillVolume' },
    ],
    'PATENT INFORMATION': [
      { name: 'Orange Book patents', code: 'Orange Book patents' },
      { name: 'Additional patents', code: 'Additional patents' },
      { name: 'Exclusivity details', code: 'Exclusivity details' },
      { name: 'PDE applied 6 months*', code: 'PDE applied 6 months*' },
      { name: 'PTE applied (Max 5 years)', code: 'PTE applied (Max 5 years)' },
      { name: 'IPR details (if any)', code: 'IPR details (if any)' },
      { name: 'Anticipated Market Formation Date', code: 'Anticipated Market Formation Date' },
      { name: '505 B(2) Opportunity', code: '505 B(2) Opportunity' },
      { name: 'Additional comments on patents', code: 'Additional comments on patents' },
      { name: 'Delisted patents', code: 'Delisted patents' },
      { name: 'Type of Filing', code: 'Type of Filing' },
      { name: 'Newly added Patents', code: 'Newly added Patents' },
    ],
    'REGULATORY INFORMATION': [
      { name: 'NCE-1 date (dd-mm-yyyy)', code: 'NCE-1 date (dd-mm-yyyy)' },
      { name: 'Reference Listed Drug (RLD)', code: 'Reference Listed Drug (RLD)' },
      { name: 'Reference Standard (RS)', code: 'Reference Standard (RS)' },
      { name: 'Orphan Drug Exclusivity', code: 'Orphan Drug Exclusivity' },
      { name: 'FDA product specific BE guidance', code: 'FDA product specific BE guidance' },
      { name: 'Eligible for CGT exclusivity*', code: 'Eligible for CGT exclusivity*' },
      { name: 'Type of BE study', code: 'Type of BE study' },
      { name: 'Additional Comments on Regulatory Information', code: 'Additional Comments on Regulatory Information' },
      { name: 'Petitions filed', code: 'Petitions filed' },
      { name: 'Possibility of Petition', code: 'Possibility of Petition' },

    ],
    'CLINICAL INFORMATION': [
      { name: 'Indications under clinical investigation / Condition', code: 'Indications under clinical investigation / Condition' },
      { name: 'Therapeutic class / AHFS Codes', code: 'Therapeutic class / AHFS Codes' },
      { name: 'ATC codes / Class', code: 'ATC codes / Class' },
      { name: 'Therapeutic Category', code: 'Therapeutic Category' },
      { name: 'REMS', code: 'REMS' },
      { name: 'Black-Box Warning', code: 'Black-Box Warning' },
      { name: 'Half-life (hrs)', code: 'Half-life (hrs)' },
      { name: 'Pharmacology', code: 'Pharmacology' },
      { name: 'Variability (% ISCV)', code: 'Variability (% ISCV)' },
      { name: 'PK Linearity', code: 'PK Linearity' },
      { name: 'Food effect', code: 'Food effect' },
      { name: 'No of analytes', code: 'No of analytes' },
      { name: 'Other studies (if any)', code: 'Other studies (if any)' },
      { name: 'Additional Comments on Clinical Info', code: 'Additional Comments on Clinical Info' },
      { name: 'No of Pilot Studies', code: 'No of Pilot Studies' },
      { name: 'Per subject cost(One analyte)', code: 'Per subject cost(One analyte)' },
      { name: 'Per subject cost(Two analyte)', code: 'Per subject cost(Two analyte)' },
      { name: 'PKPD type studies', code: 'PKPD type studies' },
      { name: 'Lifecycle Management', code: 'Lifecycle Management' },
      { name: 'Patient Population', code: 'Patient Population' }

    ],
    'API INFORMATION': [
      { name: 'Generic Name of API', code: 'Generic Name of API' },
      { name: 'BCS class', code: 'BCS class' },
      { name: 'Potential API suppliers list', code: 'Potential API suppliers list' },
      { name: 'Existing DMF filers', code: 'Existing DMF filers' },
      { name: 'API Availibility', code: 'API Availibility' },
      { name: 'Additional Info on API availibility', code: 'Additional Info on API availibility' },
    ],
    'FORMULATION INFORMATION': [
      { name: 'Qualitative composition (Q1)', code: 'Qualitative composition (Q1)' },
      { name: 'Quantitative composition (Q2)', code: 'Quantitative composition (Q2)' },
      { name: 'Shelf Life', code: 'Shelf Life' },
      { name: 'Pack Type', code: 'Pack Type' },
      { name: 'No of units per Pack', code: 'No of units per Pack' },
      { name: 'Single dose / Multiple dose', code: 'Single dose / Multiple dose' },
      { name: 'Additional comments on Formulation', code: 'Additional comments on Formulation' },
    ],
    'COMPETITIVE INTELLIGENCE': [
      { name: 'Approved ANDA filers', code: 'Approved ANDA filers' },
      { name: 'Tentatively approved ANDAs', code: 'Tentatively approved ANDAs' },
      { name: 'Filed ANDA', code: 'Filed ANDA' },
      { name: 'Expected ANDA Entrants', code: 'Expected ANDA Entrants' },
      { name: 'No of shared FTFs', code: 'No of shared FTFs' },
      { name: 'Innovator / RLD Price ($/pack)', code: 'Innovator / RLD Price ($/pack)' },
      { name: 'Indicative API price ($/kg)', code: 'Indicative API price ($/kg)' },
      { name: 'Competing products', code: 'Competing products' },
      { name: 'Reported sales', code: 'Reported sales' },
      { name: 'Reported volume', code: 'Reported volume' },
      { name: 'Drug in Shortage currently?', code: 'Drug in Shortage currently?' },
      { name: 'Additional comments on Competitive Intelligence', code: 'Additional comments on Competitive Intelligence' },
      { name: '180 Day Exclusivity', code: '180 Day Exclusivity' },
      { name: 'Current Market Shares(%)', code: 'Current Market Shares(%)' },
      { name: 'Probable API source?', code: 'Probable API source?' },
      { name: 'Comment (if any)', code: 'Comment (if any)' },
      { name: 'Total api consumption in kg', code: 'Total api consumption in kg' },
      { name: 'Peak Sale Insights', code: 'Peak Sale Insights' },

    ],
    'EXECUTIVE SUMMARY': [
      { name: 'Genericized', code: 'Genericized' },
      { name: 'Launch on approval?', code: 'Launch on approval?' },
      { name: 'First to file?', code: 'First to file?' },
      { name: 'First to launch?', code: 'First to launch?' },
      { name: 'Complexity', code: 'Complexity' },
      { name: 'Cumulative Investment($ Mn)', code: 'Cumulative Investment($ Mn)' },
      { name: 'Cumulative revenue projection($ Mn)', code: 'Cumulative revenue projection($ Mn)' },
      { name: 'Peak annual sales(Mn $)', code: 'Peak annual sales(Mn $)' },
      { name: 'IRR( %)', code: 'IRR( %)' },
      { name: 'Gross Profit', code: 'Gross Profit' },
      { name: 'Earliest Filing possibility', code: 'Earliest Filing possibility' },
      { name: 'Competition', code: 'Competition' },
    ],
    'COSTING RELATED AND DETAILS': [
      { name: 'New Possible Strengths', code: 'New Possible Strengths' },
      { name: 'Stability', code: 'Stability' },
      { name: 'BE / Regulatory', code: 'BE / Regulatory' },
      { name: 'Process', code: 'Process' },
      { name: 'Extensive Characterization', code: 'Extensive Characterization' },
      { name: 'Dev Challenge', code: 'Dev Challenge' },
      { name: 'IP Strategy', code: 'IP Strategy' },
      { name: 'No of Patents Challenged', code: 'No of Patents Challenged' },
      { name: 'Strength / API Content', code: 'Strength / API Content' },
      { name: 'Packaging', code: 'Packaging' },
      { name: 'Technology', code: 'Technology' },
      { name: 'Priority review for ANDA possible?', code: 'Priority review for ANDA possible?' },
      { name: 'Unverified activities (API supply)', code: 'Unverified activities (API supply)' },
      { name: 'Fermantation product? (Yes / No)', code: 'Fermantation product? (Yes / No)' },
    ],
  };

  constructor(private fb: FormBuilder, private http: HttpClient, private toastService: ToastMessageService, private RightsWiseLoginService: RightsWiseLoginService) {
    this.userForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      user_type: ['', Validators.required],
      selectedPageAccess: [[]],
      selectedSidebarAccess: [[]],
      selectedLmsAccess: [[]],
      selectedSection: [[]],
      selectedFields: [[]],

    });
    this.userForm.get('selectedSection')?.valueChanges.subscribe((section: string) => {
      this.selectedSection = section;  // Update the selected section
      // You can perform any additional logic when the section changes, if needed
    });
  }

  onSectionChange(event: any) {
    // If needed, perform additional operations when the section changes
    console.log('Selected sectionss:', this.selectedSection);
  }

  getFieldsForSections(selectedSections: any): any[] {
    if (Array.isArray(selectedSections)) {
      const allFields = selectedSections.reduce((acc, section) => {
        const sectionValue = section?.name || section;
        const fields = this.fieldOptionsBySection[sectionValue] || [];
        return acc.concat(fields);
      }, []);
      return allFields;
    }
    return [];
  }

  // getFieldsForSections(selectedSections: any) {
  //   // If selectedSections is an array, process each section
  //   if (Array.isArray(selectedSections)) {
  //     // Merge all fields for each selected section and remove duplicates
  //     const allFields = selectedSections.reduce((acc, section) => {
  //       const sectionValue = section?.name || section;
  //       const fields = this.fieldOptionsBySection[sectionValue] || [];
  //       // Merge the fields and avoid duplicates based on label
  //       fields.forEach(field => {
  //         if (!acc.some(existingField => existingField.name === field.name)) {
  //           acc.push(field);
  //         }
  //       });
  //       return acc;
  //     }, []);

  //     return allFields.map(field => field.name);
  //   }

  //   // If only a single section is selected, return fields for that section
  //   const sectionValue = selectedSections?.code || selectedSections?.name;
  //   console.log("sectionValue", sectionValue)
  //   const fields = this.fieldOptionsBySection[sectionValue] || [];
  //   console.log("fields", fields)
  //   return fields.map(field => field.name);
  // }


  isLMSSelected(): boolean {
    return this.selectedSidebarOption.some(option => option.code === 'LMS');
  }

  isLMSDBSelected(): boolean {
    const selectedCodes = ['LMS DB', 'LMS DS', 'LMS SU', 'LMS MS', 'LMS EX-DB', 'LMS EL', 'LMS RC', 'LMS EX-DB-IM', 'LMS Business Case', 'LMS ELR', 'LMS CL-AI'];
    return this.userForm.value.selectedLmsAccess?.some(option => selectedCodes.includes(option.code));
  }

  // isLMSDBSelected(): boolean {
  //   return this.userForm.value.selectedLmsAccess?.some(option => option.code === 'LMS DB');
  // }

  SearchMoleculeSelected(): boolean {
    return this.selectedSidebarOption.some(option => option.code === 'Search Molecule');
  }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    console.log("thisssss", this.email)
    this.resetForm(); // Reset the form on page load
    this.getUserData();
  }

  showDeleteDialog(id: string, email: string) {
    this.deleteUserId = id;
    this.deleteUserEmail = email;
    this.displayDeleteDialogBox = true;
  }

  showUpdateDialog() {
    this.displayUpdateDialogBox = true;
  }

  onCancelUpdate() {
    this.displayUpdateDialogBox = false;
  }

  confirmUpdate() {
    this.onUpdate(); // Call the actual update function
    this.displayUpdateDialogBox = false; // Close the dialog
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  onSubmit() {
    if (this.userForm.valid) {
      console.log("Form Data:", this.userForm.value);
      const formData = {
        email: this.userForm.value.email,
        password: this.userForm.value.password,
        user_type: this.userForm.value.user_type,
        page_access: this.transformAccessOptions(this.pageAccessOptions, this.userForm.value.selectedPageAccess),
        sidebar_access: this.transformAccessOptions(this.sidebarAccessOptions, this.userForm.value.selectedSidebarAccess),
        lms_access: this.transformAccessOptions(this.lmsAccessOptions, this.userForm.value.selectedLmsAccess),
        lms_sections_access: this.transformAccessOptions(this.sectionDropdownOptions, this.userForm.value.selectedSection),  // Add selected sections
        lms_field_access: this.transformFieldOptionsBySection(this.fieldOptionsBySection, this.userForm.value.selectedFields) // Add for field dropdown selections
      };
      console.log("formData", formData);
      console.log("lms_field_access", formData.lms_field_access)

      this.RightsWiseLoginService.registerUser(formData, this.email).subscribe((response) => {
        console.log("response", response);
        if (response['message'] === 'User registered successfully!') {
          this.resetForm();
          this.toastService.success('User registered successfully!');
        } else if (response['message'] === 'Email already exists!') {
          this.toastService.error('Email already exists!');
        } else {
          this.toastService.error('Registration failed. Please try again later.');
        }
        this.getUserData();

      }, error => {
        console.error('Error occurred:', error);
        this.toastService.error('An error occurred. Please try again later.');
      });
    }
  }

  confirmDelete() {
    if (this.deleteUserId && this.deleteUserEmail) {
      this.RightsWiseLoginService.deleteUser(this.deleteUserId, this.deleteUserEmail).subscribe(
        (response) => {
          console.log("User deleted successfully", response);
          this.toastService.success('User deleted successfully');
          this.getUserData();  // Refresh the data after deletion
          this.displayDeleteDialogBox = false; // Hide the dialog after deletion
        },
        (error) => {
          console.error("Error deleting user", error);
          this.toastService.error('Error deleting user. Please try again.');
          this.displayDeleteDialogBox = false; // Hide the dialog on error
        }
      );
    }
  }

  onCancelDelete() {
    this.displayDeleteDialogBox = false; // Hide the dialog without deleting
  }

  isFieldInvalid(field: string) {
    return (
      !this.userForm.get(field)?.valid &&
      this.userForm.get(field)?.touched
    );
  }

  resetForm() {
    this.userForm.reset();  // Reset the form
    // Manually reset the form controls, especially the multi-selects
    this.userForm.patchValue({
      selectedPageAccess: [],
      selectedSidebarAccess: [],
      selectedLmsAccess: [],
      selectedSection: [],
      selectedFields: []
    });
  }

  transformAccessOptions(allOptions: any[], selectedOptions: any[]): { [key: string]: boolean } {
    const accessMap: { [key: string]: boolean } = {};

    allOptions.forEach(option => {
      accessMap[option.code] = false;
    });

    // console.log("All options:", allOptions);
    // console.log("Selected options:", selectedOptions);

    selectedOptions.forEach(selected => {
      const selectedName = selected.name;

      const foundOption = allOptions.find(option => option.name === selectedName);
      if (foundOption) {
        accessMap[foundOption.code] = true;
        // console.log(`Option selected: ${selectedName}, Code: ${foundOption.code}`);
      } else {
        console.log(`Selected option not found: ${selectedName}`);
      }
    });

    return accessMap;
  }

  // transformFieldOptionsBySection(
  //   allFieldOptions: { [key: string]: any[] },
  //   selectedFields: string[]
  // ): { [key: string]: boolean } {
  //   const fieldAccessMap: { [key: string]: boolean } = {};

  //   if (!allFieldOptions || !Array.isArray(selectedFields)) {
  //     console.error("Invalid input for transformFieldOptionsBySection");
  //     return fieldAccessMap; // Return empty map
  //   }

  //   Object.keys(allFieldOptions).forEach(section => {
  //     const sectionFields = allFieldOptions[section] || [];
  //     sectionFields.forEach(field => {
  //       // Initialize all fields to false
  //       fieldAccessMap[field.code] = false;
  //     });

  //     sectionFields.forEach(field => {
  //       // Check if the field name is in selectedFields
  //       if (selectedFields.includes(field.name)) {
  //         fieldAccessMap[field.code] = true; // Mark the field as selected
  //       }
  //     });
  //   });

  //   return fieldAccessMap;
  // }

  transformFieldOptionsBySection(
    allFieldOptions: { [key: string]: any[] },
    selectedFields: any[]
  ): { [key: string]: boolean } {
    const fieldAccessMap: { [key: string]: boolean } = {};

    // Check if input is valid
    if (!allFieldOptions || !Array.isArray(selectedFields)) {
      console.error("Invalid input for transformFieldOptionsBySection");
      return fieldAccessMap; // Return empty map
    }

    Object.keys(allFieldOptions).forEach(section => {
      const sectionFields = allFieldOptions[section] || [];

      sectionFields.forEach(field => {
        fieldAccessMap[field.code] = false;
      });

      selectedFields.forEach(selectedField => {
        const selectedFieldName = selectedField.name || selectedField;
        const matchingField = sectionFields.find(
          field => field.name === selectedFieldName
        );

        if (matchingField) {
          fieldAccessMap[matchingField.code] = true;
        }
      });
    });

    return fieldAccessMap;
  }



  getUserData() {
    this.RightsWiseLoginService.getUsers(this.email).subscribe(
      (responce) => {
        this.userData = responce.data;
        console.log("user data", this.userData)
      },
      (error) => {
        console.error("Error fetching user data", error);
      }
    )
  }

  getAccessList(access: { [key: string]: boolean }): string {
    if (!access) return 'No Access';

    return Object.entries(access)
      .filter(([key, value]) => value)
      .map(([key]) => key)
      .join(', ');
  }

  // onDelete(id: string, email: string) {
  //   if (confirm("Are you sure you want to delete this user?")) {
  //     this.RightsWiseLoginService.deleteUser(id, email).subscribe(
  //       (response) => {
  //         console.log("User deleted successfully", response);
  //         this.toastService.success('User deleted successfully');
  //         this.getUserData();
  //       },
  //       (error) => {
  //         console.error("Error deleting user", error);
  //         this.toastService.error('Error deleting user. Please try again.');
  //       }
  //     );
  //   }
  // }

  onEdit(user: any) {
    console.log("user.lms_field_access", user.lms_field_access)
    this.isEditing = true;
    this.selectedUser = user;
    this.userForm.patchValue({
      email: user.email,
      password: user.password,
      user_type: user.user_type,
      selectedPageAccess: this.mapAccessToSelect(user.page_access, this.pageAccessOptions),
      selectedSidebarAccess: this.mapAccessToSelect(user.sidebar_access, this.sidebarAccessOptions),
      selectedLmsAccess: user.lms_access ? this.mapAccessToSelect(user.lms_access, this.lmsAccessOptions) : [],
      selectedSection: user.lms_sections_access ? this.mapAccessToSelect(user.lms_sections_access, this.sectionDropdownOptions) : [],
      selectedFields: this.getSelectedFieldsForSections(user, user.lms_sections_access)
    });
    console.log("userForm", this.userForm)
  }

  getSelectedFieldsForSections(user: any, sections: any): any[] {
    let selectedFields = [];

    console.log("sectionsss", sections);

    // Iterate over the keys of the sections object
    for (const sectionName in sections) {
      if (sections.hasOwnProperty(sectionName) && sections[sectionName]) {
        const sectionFields = this.fieldOptionsBySection[sectionName];
        if (sectionFields) {
          const fieldsForSection = sectionFields.filter((field: any) =>
            user.lms_field_access[field.name] === true // Check if field is marked as true in lms_field_access
          );
          selectedFields = [...selectedFields, ...fieldsForSection];
        }
      }
    }

    return selectedFields;
  }


  mapAccessToSelect(access: { [key: string]: boolean }, allOptions: any[]): any[] {
    return allOptions.filter(option => access[option.code]);
  }

  // mapAccessToSelect(access: { [key: string]: boolean }, options: any): any[] {
  //   if (Array.isArray(options)) {
  //     return options.filter(option => access[option.code]);
  //     // return options.filter(option => {
  //     //   console.log("Option Code:", option.code); // Logs field name
  //     //   console.log("Access[Option Code]:", access[option.code]); // Logs true/false
  //     //   return access[option.code];
  //     // });
  //   }
  //   return [];
  // }

  onCancel() {
    this.isEditing = false;
    this.resetForm();
  }

  onUpdate() {
    if (this.userForm.valid && this.selectedUser) {
      const updateData = {
        id: this.selectedUser.id,
        password: this.userForm.value.password,
        email: this.userForm.value.email,
        user_type: this.userForm.value.user_type,
        page_access: this.transformAccessOptions(this.pageAccessOptions, this.userForm.value.selectedPageAccess),
        sidebar_access: this.transformAccessOptions(this.sidebarAccessOptions, this.userForm.value.selectedSidebarAccess),
        lms_access: this.transformAccessOptions(this.lmsAccessOptions, this.userForm.value.selectedLmsAccess),
        lms_sections_access: this.transformAccessOptions(this.sectionDropdownOptions, this.userForm.value.selectedSection),  // Add selected sections
        lms_field_access: this.transformFieldOptionsBySection(this.fieldOptionsBySection, this.userForm.value.selectedFields) // Add for field dropdown selections
      };
      console.log("Form Data being sent for update:", updateData);

      this.RightsWiseLoginService.updateUser(updateData).subscribe(
        (response) => {
          console.log("Full Response:", response);
          if (response['message'] === 'User updated successfully!') {
            this.toastService.success('User updated successfully!');
            this.resetForm();
            this.getUserData();
            this.isEditing = false;
          } else {
            this.toastService.error('Update failed. Please try again.');
          }
        },
        (error) => {
          console.error("Error updating user:", error);
          this.toastService.error('An error occurred while updating the user.');
        }
      );
    } else {
      this.toastService.error('Form is invalid. Please check the fields.');
    }
  }
}